(() => {
  if (window.ReplicaThemeBooted) {
    window.ReplicaThemeInit?.(document);
    return;
  }
  window.ReplicaThemeBooted = true;
  const initialized = new WeakSet();

  function initAnnouncement(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    const items = Array.from(root.querySelectorAll('[data-announcement-item]'));
    if (!items.length) return;
    let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
    let timer;
    const show = (next) => {
      index = (next + items.length) % items.length;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
    };
    const restart = () => {
      window.clearInterval(timer);
      if (root.dataset.autoplay === 'true' && items.length > 1) {
        timer = window.setInterval(() => show(index + 1), Number(root.dataset.speed || 5) * 1000);
      }
    };
    root.querySelector('[data-announcement-prev]')?.addEventListener('click', () => { show(index - 1); restart(); });
    root.querySelector('[data-announcement-next]')?.addEventListener('click', () => { show(index + 1); restart(); });
    root.querySelector('[data-announcement-close]')?.addEventListener('click', () => { root.hidden = true; window.clearInterval(timer); });
    restart();
  }

  function initHeader(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);
    const drawer = root.querySelector('[data-replica-drawer]');
    const openButton = root.querySelector('[data-replica-menu-open]');
    const closeButtons = root.querySelectorAll('[data-replica-menu-close]');
    if (!drawer || !openButton) return;
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    const open = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      drawer.querySelector('button, a, summary')?.focus();
    };
    openButton.addEventListener('click', open);
    closeButtons.forEach((button) => button.addEventListener('click', close));
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-replica-announcement]').forEach(initAnnouncement);
    scope.querySelectorAll('[data-replica-header]').forEach(initHeader);
  }

  window.ReplicaThemeInit = init;

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
